'use client';
import React from 'react';
import type { Store } from './storeData';
import Icon from '@/components/ui/AppIcon';

interface StoreCardProps {
  store: Store;
  selected: boolean;
  onClick: () => void;
}

const statusConfig = {
  open: { label: 'Açık', color: 'bg-green-100 text-green-700' },
  'closing-soon': { label: 'Kapanıyor', color: 'bg-amber-100 text-amber-700' },
  closed: { label: 'Kapalı', color: 'bg-red-100 text-red-600' },
};

export default function StoreCard({ store, selected, onClick }: StoreCardProps) {
  const status = statusConfig[store.status];

  return (
    <button
      onClick={onClick}
      className={`w-full text-left bg-card rounded-2xl p-4 card-shadow border-2 transition-all duration-150 active:scale-[0.99] ${
        selected ? 'border-primary' : 'border-transparent hover:border-primary/20'
      }`}
    >
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${selected ? 'bg-primary' : 'bg-accent'}`}>
          <Icon name="MapPinIcon" size={20} className={selected ? 'text-white' : 'text-primary'} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-1">
            <h3 className="text-foreground font-bold text-sm leading-tight">{store.name}</h3>
            <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full flex-shrink-0 ${status.color}`}>
              {status.label}
            </span>
          </div>
          <p className="text-muted-foreground text-xs mb-2 leading-relaxed">{store.address}</p>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1">
              <Icon name="MapPinIcon" size={12} className="text-primary" />
              <span className="text-primary text-xs font-semibold">{store.distance}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="ClockIcon" size={12} className="text-muted-foreground" />
              <span className="text-muted-foreground text-xs">{store.hours}</span>
            </div>
          </div>
          {/* Amenity chips */}
          <div className="flex flex-wrap gap-1 mt-2">
            {store.driveThru && (
              <span className="text-[10px] bg-muted text-muted-foreground px-2 py-0.5 rounded-full font-medium">🚗 Drive-Thru</span>
            )}
            {store.wifi && (
              <span className="text-[10px] bg-muted text-muted-foreground px-2 py-0.5 rounded-full font-medium">📶 WiFi</span>
            )}
            {store.outdoor && (
              <span className="text-[10px] bg-muted text-muted-foreground px-2 py-0.5 rounded-full font-medium">🌿 Dış Alan</span>
            )}
            {store.parkingAvailable && (
              <span className="text-[10px] bg-muted text-muted-foreground px-2 py-0.5 rounded-full font-medium">🅿️ Otopark</span>
            )}
          </div>
        </div>
      </div>
    </button>
  );
}